
import React from "react";
import MilligramLoading from "../assets/milligram_loader.svg";
import styled from "styled-components";


const SVGContainer = styled.div`
    width: 100%;    
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const MilliLoader = styled(MilligramLoading)`
    height: 46px;
`
const LoadingScreen = () => {
    return (
        <>
            <SVGContainer>
                <MilliLoader />
            </SVGContainer>

        </>
    );
}

export default LoadingScreen